import React, { memo, useState, useCallback } from "react";
import PropTypes from "prop-types";
import {
  HStack,
  Button,
  Textarea,
  Input,
  FormControl,
  FormHelperText,
  FormLabel,
  Stack,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import { BiHelpCircle } from "react-icons/bi";
import { translate as trans } from "../Trans/Trans";
import RequiredIndicator from "../RequiredIndicator/RequiredIndicator";

const SnippetForm = ({ editText, editTitle, onSave, onCancel }) => {
  const [values, setValues] = useState({ text: editText, title: editTitle });
  const [error, setError] = useState();

  const handleChange = useCallback(
    (event) => {
      setValues({
        text: values.text,
        title: values.title,
        [event.target.name]: event.target.value,
      });
    },
    [setValues, values]
  );

  const handleSave = useCallback(() => {
    if (!values.text) {
      setError(true);
    } else {
      setError();
      onSave?.(values);
    }
  }, [values, onSave]);

  return (
    <>
      <Stack spacing={2}>
        <FormControl isInvalid={error}>
          <FormLabel fontSize="sm">
            {trans("snippets.content")}
            <RequiredIndicator />
          </FormLabel>
          <Textarea
            size="sm"
            name="text"
            onChange={handleChange}
            value={values.text}
            placeholder={trans("snippets.enter_snippet")}
          />
          {error && (
            <FormHelperText>
              {trans("snippets.enter_snippet_error")}
            </FormHelperText>
          )}
        </FormControl>
        <FormControl>
          <FormLabel fontSize="sm">
            {trans("snippets.title")}
            &nbsp;
            <Tooltip
              label={trans("snippets.title_tip")}
              shouldWrapChildren
              placement="top"
              hasArrow
            >
              <Icon as={BiHelpCircle} />
            </Tooltip>
          </FormLabel>
          <Input
            size="sm"
            onChange={handleChange}
            value={values.title}
            name="title"
            placeholder={trans("snippets.title")}
          />
        </FormControl>
        <HStack spacing={2} mt={2}>
          <Button onClick={handleSave} size="xs" variant="solid">
            {trans("generic.save")}
          </Button>
          <Button onClick={onCancel} size="xs">
            {trans("generic.cancel")}
          </Button>
        </HStack>
      </Stack>
    </>
  );
};

SnippetForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  editText: PropTypes.string,
  editTitle: PropTypes.string,
};

SnippetForm.defaultProps = {
  editText: "",
  editTitle: "",
};

export default memo(SnippetForm);
